import { DataErrorType } from "../model/Error/DataError";
var _window = window;
function getQuery(n) {
    var m = window.location.search.match(new RegExp('(\\?|&)' + n + '=([^&]*)(&|$)'));
    return !m ? '' : decodeURIComponent(m[2]);
}
function isNoResultError(error) {
    return error.errorType === DataErrorType.NO_RESULT_ERROR;
}
/**
 * 包一下data   因为有些数据是从数据库直接读出来的  实际上不是对象 只是普通Object 没有相应的方法，wrap之后 就有方法了
 * @param data
 * @param targetClassType 目标类  只有目标类的实例 才会进行wrap
 */
function wrapData(data, targetClassType) {
    if (Array.isArray(data)) {
        return data.map(function (item) {
            return new targetClassType.prototype.constructor(item);
        });
    }
    else {
        return new targetClassType.prototype.constructor(data);
    }
}
/**
 * 包裹IndexedDB查询结果
 * @param classType 要包裹的类的构造函数
 */
function wrapResult(classType, className) {
    return function (target, propertyKey, descriptor) {
        var originFun = descriptor.value;
        descriptor.value = function () {
            var ret = originFun.apply(this, arguments);
            if (arguments[0] === className) { // 只针对对应的类才做wrap
                return ret.then(function (result) {
                    if (result.error) {
                        return result;
                    }
                    result.data = wrapData(result.data, classType);
                    return result;
                });
            }
            return ret;
        };
    };
}
/**
 * 用于浏览器下调试离线
 */
function checkDebugOffline() {
    var debug = getQuery('offline-debug');
    if (debug === '1') {
        return true;
    }
    return false;
}
/**
 * 判断两个数值大小
 * @param valueA
 * @param valueB \
 * @param open true的时候开区间 false的嘶吼闭区间
 */
function isALowerB(valueA, valueB, open) {
    if (open === void 0) { open = true; }
    if (open) {
        return valueA < valueB;
    }
    else {
        return valueA <= valueB;
    }
}
export { isNoResultError, isALowerB, checkDebugOffline, wrapResult, wrapData };
//# sourceMappingURL=utils.js.map